import { useEffect } from 'react';
import firebase from 'firebase/app';

export default function useFirebaseEvent(eventName: string, eventParams?: any) {
  useEffect(() => {
    firebase.analytics().logEvent(eventName, eventParams);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
